import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { AutomataOperationsService } from '@vendasta/automata';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { throwError } from 'rxjs';
import { catchError, finalize, take, tap } from 'rxjs/operators';

interface NextStepOption {
  name: string;
  id: string;
}

interface DialogData {
  automationId: string;
  runId: string;
  entityId: string;
  workflowStepId: string;
  nextStepOptions: NextStepOption[];
}

@Component({
  templateUrl: './continue-on-new-step-dialog.component.html',
  styleUrls: ['./continue-on-new-step-dialog.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    GalaxyAlertModule,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    GalaxyWrapModule,
  ],
})
export class ContinueOnNewStepDialogComponent {
  processing: boolean;
  selectedStepControl = new UntypedFormControl('', Validators.required);

  constructor(
    public dialogRef: MatDialogRef<ContinueOnNewStepDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    protected readonly snackbarService: SnackbarService,
    private readonly automataOperationsService: AutomataOperationsService,
  ) {}

  continueOnNewStep(): void {
    this.processing = true;
    this.automataOperationsService
      .continueAutomationFromStep(
        this.data.automationId,
        this.data.entityId,
        this.data.runId,
        this.data.workflowStepId,
        this.selectedStepControl.value,
      )
      .pipe(
        take(1),
        catchError((e) => {
          this.snackbarService.openErrorSnack('AUTOMATIONS.CONTINUE_ON_NEW_STEP.ERROR_GENERIC');
          return throwError(() => e);
        }),
        tap(() => {
          this.snackbarService.openSuccessSnack('AUTOMATIONS.CONTINUE_ON_NEW_STEP.SUCCESS');
          this.dialogRef.close(true);
        }),
        finalize(() => (this.processing = false)),
      )
      .subscribe();
  }
}
